import { FC, useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch } from '../../../redux/reducer/store';

import { actionGetProjectsList } from '../../../redux/action/projects/actionProjects';
import { actionGetRoutes } from '../../../redux/action/projects/actionRoutes';
import {
  reducerCreateVacancyInputValues,
  reducerHandleErrors,
  reducerAddRoutesListOptions,
} from '../../../redux/reducer/recruiting/reducers/reducerCreateVacancy';

import {
  reducerRoutesInputValues
} from '../../../redux/reducer/projects/reducers/reducerRoutesList';

import Select from '../../custom/select/select';
import CustomMultiSelect from '../../custom/customMultiSelect/customMultiSelect';
import Loader from '../../custom/loader/loader';

import clsx from 'clsx';

import styles from './recruiting.module.scss';

const typeFilter = [
  { value: 'ON_ROUTE', label: 'Связана с маршрутом' },
  { value: 'NO_ROUTE', label: 'Не связана с маршрутом' },
  { value: 'LOST_ROUTE', label: 'Потеряна связь с маршрутом' },
  { value: 'PARTIAL_ROUTE', label: 'Частично связана с маршрутом' },
];
const TableVacancyCreate: FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { id } = useParams<{ id: any }>();
  const [selectedActions, setSelectedActions] = useState<any>([]);
  const [selectedActionsProjects, setSelectedActionsProjects] = useState<any>([]);
  const [currentProject, setCurrentProject] = useState<any>()
  const {
    projects,
    limit,
    pages,
  } = useSelector((state: any) => state.projects.projects);
    
  const { routesInputValues } = useSelector((state: any) => state.projects.routes);
  const { vacancyCreateInputValues, errors, routesListOptions } = useSelector(
    (state: any) => state.recruiting.createVacancy
  );
  const {
    data: routes,
    page,
    selectedRoutesNo
  } = useSelector((state: any) => state.projects.routes);
  const actualLimit =
    JSON.parse(localStorage.getItem('pageLimit') as string) || limit;

    const projectsArr = projects.map((obj: any) => {
    return { label: obj.name, value: obj };
  });

  const [isPending, setIsPending] = useState<boolean>(false);
  const newRoutesListOptions = id ? routesListOptions : routesListOptions && routesListOptions.map((el: any) => {
    return { value: el.value, label: `${el.value.routeNo} ${el.value.project.name}` };
  });
  function getRoutes() {
    setIsPending(true);
    dispatch(reducerRoutesInputValues({...routesInputValues, canBeAttachedToVacancy: true}))
    dispatch(actionGetRoutes(limit, page)).then(() => {
      dispatch(reducerRoutesInputValues({...routesInputValues, canBeAttachedToVacancy: null}))
      setIsPending(false);
    });
  };

  const selectChange = (event: any, name: string) => {
    const value = event.value;
    if (value === 'NO_ROUTE' || value === 'LOST_ROUTE') {
      const { routesNo, ...temp } = vacancyCreateInputValues;
      const newObject = { ...temp, [name]: value }
      dispatch(reducerCreateVacancyInputValues(newObject));
    } else
      dispatch(reducerCreateVacancyInputValues({ ...vacancyCreateInputValues, 'type': value, }));
        if ((value !== 'NO_ROUTE' && value !== 'LOST_ROUTE') &&
          (currentProject || vacancyCreateInputValues?.projects?.length > 0)) {
            getRoutes();
        }
  };

  useEffect(() => {
    if (selectedActions && selectedActions?.length > 0) {
      dispatch(reducerCreateVacancyInputValues({
        ...vacancyCreateInputValues, routesNo: selectedActions
      }))
    } else {
      dispatch(reducerCreateVacancyInputValues({
        ...vacancyCreateInputValues, routesNo: null
      }))
    }
    // eslint-disable-next-line
  }, [selectedActions]);

  useEffect(() => {
    if (selectedActionsProjects && selectedActionsProjects?.length > 0) {
      const tempInputValues = {...vacancyCreateInputValues};
      delete tempInputValues.projectRoutes;
      delete tempInputValues.routesNo;
      dispatch(reducerCreateVacancyInputValues({
        ...tempInputValues, projects: selectedActionsProjects
      }));
      dispatch(reducerHandleErrors([]));
      if ((vacancyCreateInputValues.type !== 'NO_ROUTE' && vacancyCreateInputValues.type !== 'LOST_ROUTE')){
        getRoutes();
      }
    } else {
      dispatch(reducerCreateVacancyInputValues({
        ...vacancyCreateInputValues, projects: null
      }))
    }

    // eslint-disable-next-line
  }, [selectedActionsProjects]);

  useEffect(() => {
    if (selectedRoutesNo && selectedRoutesNo?.length > 0) {
      const temp = selectedRoutesNo.map((el: any) => el.id)
      dispatch(reducerCreateVacancyInputValues({
        ...vacancyCreateInputValues, routesNo: temp
      }))
    }
    // eslint-disable-next-line
  }, [selectedRoutesNo]);

  useEffect(() => {
    if (projects.length === 0) {
      setIsPending(true);
      dispatch(actionGetProjectsList(actualLimit, pages)).then(() => {
        setIsPending(false);
      });
    }
  }, [actualLimit, dispatch, pages, projects]);

  useEffect(() => {
    if (errors && errors.length > 0 && vacancyCreateInputValues.type) {
      const temp = errors.filter((err: any) => err !== 'errorType');
      dispatch(reducerHandleErrors(temp));
    }

    if (errors && errors.length > 0 && vacancyCreateInputValues.project) {
      const temp = errors.filter((err: any) => err !== 'errorProject');
      dispatch(reducerHandleErrors(temp));
    }

    if (errors && errors.length > 0 && vacancyCreateInputValues.routesNo) {
      const temp = errors.filter((err: any) => err !== 'errorRoutesNo');
      dispatch(reducerHandleErrors(temp));
    }
    // eslint-disable-next-line
  }, [vacancyCreateInputValues, dispatch]);
  useEffect(() => {
    if (id) {
      const currentProject = projects.filter((el: any) => el.id === parseInt(id))[0]
      setCurrentProject(currentProject)
      dispatch(reducerCreateVacancyInputValues(
        {
          ...vacancyCreateInputValues,
          project: currentProject.project
        }
      ));
    }
    // eslint-disable-next-line
  }, [id, projects, dispatch])
  useEffect(() => {
    dispatch(reducerAddRoutesListOptions({ routes, vacancyCreateInputValues }))
  }, [dispatch, routes, vacancyCreateInputValues]);
  useEffect(() => {
    if(!vacancyCreateInputValues.projects && currentProject) {
      dispatch(reducerCreateVacancyInputValues({ ...vacancyCreateInputValues, projects: [currentProject] }));
    }
     // eslint-disable-next-line
  }, [currentProject]);
  return (
    <>
      <div className='loader__wrapper'>{isPending && <Loader />}</div>
      <div className='createVacancyTable'>
        <div className={styles.tableWrapper}>
          <div>
            <div className={styles.vacancyBlock}>
              <span className='section__title'>Проект</span>
              <form action=''>

                <div className={styles.subBlock}>
                  <div className={styles.subBlock__left}>
                    <span className={styles.blockTitle}>Тип вакансии</span>
                  </div>
                  <div className={styles.subBlock__right}>
                    <div className={styles.filterInput}>
                      <Select
                        defaultValue='NO_ROUTE'
                        propsChange={(event: any) =>
                          selectChange(event, 'type')
                        }
                        options={typeFilter.map((el: any) => ({
                          value: el.value,
                          label: el.label,
                        }))}
                        className={clsx(
                          styles.filterSelect,
                          errors && errors.includes('errorType') && styles.error
                        )}
                        placeholder='Не связана с маршрутом'
                        name='type'
                      />
                    </div>
                  </div>
                </div>

                <div className={styles.subBlock}>
                  <div className={styles.subBlock__left}>
                    <span className={styles.blockTitle}>Проект</span>
                  </div>
                  <div className={styles.subBlock__right}>
                    {!currentProject ? (
                       <div className={clsx('reports__region_block')}>
                      <CustomMultiSelect
                        pageName='createVacancy'
                        setState={setSelectedActionsProjects}
                        options={projectsArr}
                        placeholder='Выберите'
                        name="projects"
                        inputValues={{ projects: vacancyCreateInputValues.projects }}
                        reducer={reducerCreateVacancyInputValues}
                        action={() => {}}
                        activeOptions={selectedActionsProjects}
                        classNames={errors && errors.includes('errorProject')}
                      />
                    </div>) : (
                      <div className={styles.subBlock__right__text}>
                        {currentProject && currentProject?.name}
                      </div>
                    )}
                  </div>
                </div>

                {(!(vacancyCreateInputValues?.type === 'NO_ROUTE' ||
                  vacancyCreateInputValues?.type === 'LOST_ROUTE') && (currentProject || vacancyCreateInputValues.projects)) &&
                  <div className={styles.subBlock}>
                    <div className={styles.subBlock__left}>
                      <span className={styles.blockTitle}>Маршрут</span>
                    </div>
                    <div className={styles.subBlock__right}>
                      {selectedRoutesNo && selectedRoutesNo.length < 1 ? (
                        <div className={clsx('reports__region_block')}>
                          <CustomMultiSelect
                            pageName='createVacancy'
                            setState={setSelectedActions}
                            options={newRoutesListOptions}
                            placeholder='Выберите'
                            name="actions"
                            inputValues={{ actions: vacancyCreateInputValues.routesNo }}
                            reducer={reducerCreateVacancyInputValues}
                            action={() => {}}
                            activeOptions={vacancyCreateInputValues.routesNo}
                            classNames={errors && errors.includes('errorRoutesNo')}
                          />
                        </div>
                      ) : (
                        <div className={styles.subBlock__right__text}>
                          {selectedRoutesNo
                            .map((el: any) =>
                              el.id
                            )
                            .join(', ')}
                        </div>
                      )}
                    </div>
                  </div>}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TableVacancyCreate;
